import { SchoolLpPage, SchoolLpPageProps } from '~/features/school-lp/components/school-lp-page';
import { createSchoolLpGetStaticProps } from '~/features/school-lp/controllers/get-school-lp-props';

const SCHOOL_SLUG = 'cloud-computing';

export default function CloudComputingSchoolPage(props: Omit<SchoolLpPageProps, 'schoolSlug'>) {
  return <SchoolLpPage schoolSlug={SCHOOL_SLUG} {...props} />;
}

export const getStaticProps = createSchoolLpGetStaticProps(SCHOOL_SLUG);
